import React from "react";
import Synonyms from "./Synonyms";
import "./Meaning.css";

export default function Meaning(props) {
  return (
    <div className="Meaning">
      <h3>{props.meaning.partOfSpeech}</h3>
      {props.meaning.definitions.map(function (definition, index) {
        if (definition.example) {
          return (
            <div key={index} className="wordInfo">
              <div className="definition">{definition.definition}</div>
              <div className="example"> Example: {definition.example} </div>
              <Synonyms synonyms={definition.synonyms} />
            </div>
          );
        } else {
          return (
            <div key={index} className="wordInfo">
              <div className="definition"> {definition.definition} </div>
              <Synonyms synonyms={definition.synonyms} />
            </div>
          );
        }
      })}
    </div>
  );
}
